<template>
  <div class="orderlist">
<v-card>
  <v-card-title>
    <img src="../../../static/images/icon8icons/icons8-purchase-order-50.png" />
    <h1>Orders</h1>
    <v-spacer/>
    <v-btn @click="showSearch = !showSearch" flat color="accent">
       <v-icon class="mr-1">{{$vuetify.icons.search}}</v-icon>
       Search
      <v-icon class="ml-1">{{showSearch ? $vuetify.icons.up : $vuetify.icons.down}}</v-icon>

    </v-btn>
    <OrderSearchSettings :show="showSearch"></OrderSearchSettings>
  </v-card-title>

  <v-data-table
    v-if="$vuetify.breakpoint.mdAndUp"
    :headers="headers"
    :items="computedOrders"
    :loading="ordersLoading"
    :pagination.sync="pagination"
    mustSort
    class="elevation-1"
    no-data-text="No orders found."
  >
    <template
      slot="items"
      slot-scope="props"
    >
      <tr @click='$emit("viewOrder", { "orderData" : props.item })' style="cursor:pointer">
        <td class="body-2 text-xs-left">{{ props.item.formattedDate }}</td>
        <td class="body-2 text-xs-left">{{ props.item.buyerDetails.name }}</td>
        <td class="body-2 text-xs-left">{{ props.item.numItems }}</td>
        <td class="body-2 text-xs-left">{{ props.item.formattedPrice }}</td>
        <td class="body-2 text-xs-left">{{ props.item.deliveryDetails.type }}</td>
        <td :class="props.item.paymentClass">{{ props.item.paymentStatus }}</td>
        <td :class="props.item.deliveryClass">{{ props.item.deliveryStatus }}</td>
      </tr>
    </template>

  </v-data-table>

  <v-container v-if="$vuetify.breakpoint.smAndDown" fluid grid-list-md>
    <v-data-iterator
      :items="computedOrders"
      content-tag="v-layout"
      :loading="ordersLoading"
      :pagination.sync="pagination"
      mustSort
      class="elevation-1"
      no-data-text="No orders found."

      row
      wrap
    >
      <template slot="item" slot-scope="props">
        <v-flex
            xs12
            sm6
            md4
            lg3
          >
          <v-card @click='$emit("viewOrder", { "orderData" : props.item })' class="clickable" >
              <v-card-title class="subheading font-weight-bold">{{ props.item.buyerDetails.name  }} {{ props.item.formattedDate }}</v-card-title>

              <v-divider></v-divider>

              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>Buyer:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ props.item.buyerDetails.name  }}</v-list-tile-content>
                </v-list-tile>

                <v-list-tile>
                  <v-list-tile-content>Number of Itemrs:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ props.item.numItems }}</v-list-tile-content>
                </v-list-tile>

                <v-list-tile>
                  <v-list-tile-content>Price:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ props.item.formattedPrice }}</v-list-tile-content>
                </v-list-tile>

                <v-list-tile>
                  <v-list-tile-content>Delivery:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ props.item.deliveryDetails.type }}</v-list-tile-content>
                </v-list-tile>

                <v-list-tile :class="props.item.paymentClass">
                  <v-list-tile-content class="body-2">Payment Status:</v-list-tile-content>
                  <v-list-tile-content class="body-2 align-end">{{ props.item.paymentStatus }}</v-list-tile-content>
                </v-list-tile>

                <v-list-tile :class="props.item.deliveryClass">
                  <v-list-tile-content class="body-2">Delivery Status:</v-list-tile-content>
                  <v-list-tile-content class="body-2 align-end">{{ props.item.deliveryStatus }}</v-list-tile-content>
                </v-list-tile>

              </v-list>
            </v-card>
          </v-flex>
      </template>
    </v-data-iterator>
  </v-container>

</v-card>

      <hr />
      <ReturnToDashboard></ReturnToDashboard>
</div>

</template>

<script>
import {mapState} from 'vuex'
import utils from '../../utils.ts'
import OrderSearchSettings from './OrderSearchSettings'
import ReturnToDashboard from './ReturnToDashboard'

export default {
  name: 'Orders',
  components: {
    OrderSearchSettings, ReturnToDashboard
  },
  data () {
    return {
      pagination: {
          descending: true,
          sortBy: 'date',
      },
      showSearch: false,
      loading: false,
      headers: [
        {text: 'Order Date', value: 'date', align: 'left'},
        {text: 'BuyerName', value: 'buyerDetails.name', align: 'left'},
        {text: '# items', value: 'numItems', align: 'left'},
        {text: 'Cost', value: 'totalPrice', align: 'left'},
        {text: 'Delivery Type', value: 'deliveryDetails.type', align: 'left'},
        {text: 'Payment Status', value: 'paymentReceived', align: 'left'},
        {text: 'Delivery Status', value: 'delivered', align: 'right'}
      ]
    }
  },
  computed: {
    ...mapState({
      orders: state => state.admin.orders,
      ordersLoading: state => state.admin.ordersLoading,
      queryCriteria: state => state.admin.queryCriteria
    }),
    computedOrders: function () {
      const newOrders = this.orders
      for (let i = 0; i < newOrders.length; i++) {
        const order = newOrders[i]
        if (order.paymentReceived) {
          newOrders[i].paymentStatus = 'Received'
          newOrders[i].paymentClass = 'body-2 text-xs-left complete success'
        } else {
          newOrders[i].paymentStatus = 'Not received'
          newOrders[i].paymentClass = 'body-2 text-xs-left incomplete error'
        }

        if (order.delivered) {
          newOrders[i].deliveryStatus = 'Delivered'
          newOrders[i].deliveryClass = 'body-2 text-xs-right complete success'
        } else {
          newOrders[i].deliveryStatus = 'Not Delivered'
          newOrders[i].deliveryClass = 'body-2 text-xs-right incomplete error'
        }

        newOrders[i].formattedPrice = utils.formatCurrency(order.totalPrice)
        newOrders[i].formattedDate = utils.formatDate(order.date)
      }

      this.pagination['totalItems'] = newOrders.length
      return newOrders
    }

  },
  mounted: function () {
    // console.log('ITEMS: ' + this.items)
    // console.log('computedOrders: ' + JSON.stringify(this.computedOrders))
  },
  methods: {
    /*deleteOrder: function (order) {
      console.log('Delete order: should confirm')
      this.$store.dispatch('admin/deleteOrder', {'oid': order.id})
    },
    editOrder: function (order) {
      this.$emit('viewOrder', order)
    }
    */

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.orderlist {
  width: 100%;
}

.incomplete {
  font-weight: bold;
  color: white;
  padding: 10px;
}

.clickable {
  cursor:pointer;
}

.complete {
  font-weight: bold;
  color: white;
  padding: 10px;
}
</style>
